import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: { main: '#13B5EA', contrastText: '#ffffff' },
        secondary: { main: '#666766', contrastText: '#ffffff' },
        pink: { backgroundColor: '#e20177', color: '#ffffff' },
        blue: { backgroundColor: '#13B5EA', color: '#ffffff' },
        grey: { backgroundColor: '#666766', color: '#ffffff' },
        orange: { backgroundColor: '#f78e1e', color: '#ffffff' },
        green: { backgroundColor: '#C1D82F', color: '#ffffff' },
        mustard: { backgroundColor: '#E1D04D', color: '#ffffff' },
        teal: { backgroundColor: '#4FB7AA', color: '#ffffff' },
        red: { backgroundColor: '#D73816', color: '#ffffff' },
    },
    typography: {
        fontFamily: ['Imprima', 'Museo700'].join(', '),
        root: { fontFamily: ['Imprima', 'Museo700'].join(', ') },
        h1: { fontFamily: ['Museo700'].join(', '), marginBottom: 16 },
        h2: { fontFamily: ['Museo700'].join(', '), marginBottom: 16 },
        h3: { fontFamily: ['Museo700'].join(', '), marginBottom: 16 },
        h4: { fontFamily: ['Museo700'].join(', '), marginBottom: 16 },
        h5: { fontFamily: ['Museo700'].join(', '), marginBottom: 16 },
        h6: { fontFamily: ['Museo700'].join(', '), marginBottom: 16 },
    },
    tableHeadCell: {
        style: {
            backgroundColor: '#EEF2F3',
            color: '#000000',
            fontWeight: 'bold',
            textAlign: 'left',
        },
    },
    tableBoldHeadStyle: {
        style: {
            backgroundColor: '#EEF2F3',
            color: '#000000',
            fontWeight: 'bold',
            textAlign: 'left',
            fontFamily: 'Museo700',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: 'Museo700',
                    textTransform: 'none',
                    marginTop: 8,
                    marginLeft: 0,
                    marginRight: 8,
                },
            },
        },
        MuiFab: {
            styleOverrides: {
                extended: {
                    textTransform: 'none',
                    fontFamily: 'Museo700',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    '&.admin-view': {
                        background: 'linear-gradient(105deg, white 199px, #005776 199px)',
                    },
                    background: 'linear-gradient(105deg, white 199px, #13B5EA 199px)',
                    minHeight: '64px !important',
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    fontFamily: 'Museo700',
                    padding: '23px 12px',
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    backgroundColor: 'white',
                    borderTopLeftRadius: 20,
                    borderTopRightRadius: 20,
                    height: 10,
                    width: 108,
                },
            },
        },
    },
});

export default theme;
